import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { isApiError } from './api'
import { SESSION_KEY } from './auth'

/**
 * A 401 from ANY request means the session is gone. Rather than redirecting from
 * here (and once per failing query), mark the session as signed-out; RequireAuth
 * sees that and renders exactly one <Navigate> to /login. /login sits outside
 * RequireAuth, so there is nothing left to 401 and no loop.
 */
function onError(err: unknown) {
  if (isApiError(err, 401)) queryClient.setQueryData(SESSION_KEY, null)
}

export const queryClient: QueryClient = new QueryClient({
  queryCache: new QueryCache({ onError }),
  mutationCache: new MutationCache({ onError }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: (count, err) => {
        // Never retry auth or validation failures — only transient ones.
        const status = (err as { status?: number }).status
        if (status && status < 500 && status !== 429) return false
        return count < 2
      },
    },
  },
})
